import React, { useEffect } from 'react';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import axios from 'axios';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { hydrateUser } from './redux/actions/auth/authActions';
import store from './redux/Store';
import router from './routes';
import SessionManager from './auth/SessionManager';
import { getCookie } from './helpers/cookie';
import { handleAuthentication } from './helpers/auth';

const skipAuthRoutes = ['login', 'refreshToken', 'video/auth/login'];

axios.interceptors.request.use(
  function (config) {
    const skipCheck = skipAuthRoutes.some((route) =>
      config.url.includes(route),
    );

    if (!skipCheck) {
      config.headers.Authorization = `Bearer ${getCookie('accessToken')}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      if (error?.config?.url.includes('refreshToken')) {
        return Promise.reject(error);
      }
      return handleAuthentication(error);
    }
    return Promise.reject(error);
  },
);

function HydrationGate({ children }) {
  const dispatch = useDispatch();
  const hydrated = useSelector((s) => s.auth.hydrated);

  useEffect(() => {
    dispatch(hydrateUser());
  }, [dispatch]);

  if (!hydrated) return null;

  return children;
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <ToastProvider>
          <SessionManager>
            <HydrationGate>
              <RouterProvider router={router} />
            </HydrationGate>
          </SessionManager>
        </ToastProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
